<template>
  <div class="orderDetail">
    <el-dialog
      title="订单详情"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="990px"
      :before-close="handleClose"
    >
      <div>
        <el-steps
          :space="330"
          align-center
          :active="current"
          finish-status="success"
        >
          <el-step
            :title="orderData.payStatus === 2 ? '已支付' : '未支付'"
          ></el-step>
          <el-step
            :title="orderData.signType === 2 ? '已签约' : '待签约'"
          ></el-step>
          <el-step title="订单完成"></el-step>
        </el-steps>

        <div class="title">
          <div class="title_lef">基本信息</div>
          <div class="title_rig"
            v-show="orderData.payStatus === 1 &&
            orderData.auditStatus !== 1 &&
            orderData.orderState !== 6 &&
            orderData.orderSource === 1"
          >
            <span class="blue_Box" @click="toShowYPLPay">收款二维码</span>
          </div>
        </div>

        <el-table border :data="data" style="width: 100%">
          <el-table-column align="center" label="订单编号">
            <template slot-scope="{ row }">
              <span>{{ row.orderNumber || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="班级名称">
            <template slot-scope="{ row }">
              <span>{{ row.skuName || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="支付类型">
            <template slot-scope="{ row }">
              <el-tag v-if="row.payType === 'YPL'">易票联</el-tag>
              <el-tag v-else-if="row.payType === 'DGZZ'">线下转账</el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="订单来源">
            <template slot-scope="{ row }">
              <el-tag v-if="row.sourceType === 1">PC</el-tag>
              <el-tag v-else-if="row.sourceType === 2" type="success">小程序</el-tag>
              <el-tag v-else-if="row.sourceType === 3" type="info">安卓</el-tag>
              <el-tag v-else-if="row.sourceType === 4" type="danger">ios</el-tag>
              <el-tag v-else-if="row.sourceType === 5" type="warning">H5</el-tag>
              <el-tag v-else-if="row.sourceType === 6" type="warning">后台</el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="订单类别">
            <template slot-scope="{ row }">
              <el-tag v-if="row.orderSource === 1">普通订单</el-tag>
              <el-tag type="success" v-else-if="row.orderSource === 2">团购订单</el-tag>
              <el-tag type="success" v-else-if="row.orderSource === 3">内训订单</el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
        <el-table border :data="data" style="width: 100%">
          <el-table-column align="center" label="支付状态">
            <template slot-scope="{ row }">
              <el-tag v-if="row.payStatus === 1">未支付</el-tag>
              <el-tag v-else-if="row.payStatus === 2" type="success">已支付</el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="退款状态">
            <template slot-scope="{ row }">
              <el-tag v-if="row.refundStatus === 1">未退款</el-tag>
              <el-tag v-else-if="row.refundStatus === 2" type="info">退款申请中</el-tag>
              <el-tag v-else-if="row.refundStatus === 3" type="success">已退款</el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否签约">
            <template slot-scope="{ row }">
              <el-tag v-if="row.signType === 1">未签约</el-tag>
              <el-tag v-else-if="row.signType === 2" type="success">签约</el-tag>
              <el-tag v-else-if="row.signType === 3" type="info">没有合同</el-tag>
              <el-tag v-else-if="row.signType === 4" type="danger">协议签约中</el-tag>
              <el-tag v-else-if="row.signType === 5" type="warning">暂不用签约</el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="学员姓名">
            <template slot-scope="{ row }">
              <span>{{ row.name || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="手机号">
            <template slot-scope="{ row }">
              <span>{{ row.phone || "--" }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="title">费用信息</div>
        <el-table border :data="data" style="width: 100%">
          <el-table-column align="center" label="实付金额">
            <template slot-scope="{ row }">
              <span>{{ row.payAmt || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="原价">
            <template slot-scope="{ row }">
              <span>{{ row.totalAmt || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="优惠金额">
            <template slot-scope="{ row }">
              <span>{{ row.discountAmt || "--" }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="title">支付记录</div>
        <el-table border :data="orderData.orderPayList" style="width: 100%">
          <el-table-column width="100px" align="center" label="金额">
            <template slot-scope="{ row }">
              <span>{{ row.amount || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column width="120px" align="center" label="支付类型">
            <template slot-scope="{ row }">
              <el-tag v-if="row.payType === 'YPL'">易票联</el-tag>
              <el-tag v-else-if="row.payType === 'DGZZ'">线下转账</el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- <el-table-column width="110px" align="center" label="订单来源">
            <template slot-scope="{ row }">
              <span>{{ row.payWay || "--" }}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="⽀付中⼼订单号(易票联)">
            <template slot-scope="{ row }">
              <span>{{ row.payOrderNo || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="渠道侧订单号(易票联)">
            <template slot-scope="{ row }">
              <span>{{ row.outTradeNo || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column width="100px" align="center" label="交易状态">
            <template slot-scope="{ row }">
              <el-tag v-if="row.payStatus === 1">创建交易</el-tag>
              <el-tag v-else-if="row.payStatus === 2" type="success">交易成功</el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间" width="160">
            <template slot-scope="{ row }">
              <span>{{ row.insertDate || "--" }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="title" v-if="orderData.remitVoucher">支付凭证</div>
        <template v-if="orderData.urlList && orderData.urlList.length">
          <el-image
            v-for="(item, i) in orderData.urlList"
            :key="i"
            style="width: 120px; height: 120px"
            :src="item"
            :preview-src-list="orderData.urlList"
          >
          </el-image>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>

    <pay-poster
      ref="PayPoster"
      v-show="juheModal"
      :orderId="orderId"
      :companyId="companyId"
      :skuName="skuName"
      qrcodeId="qrcode003"
    ></pay-poster>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/orderAdmin/orderList";
import { getPrivateImgUrl } from "@/api/product/base";
import PayPoster from "@/views/orderAdmin/components/payPoster.vue";
export default {
  components: {
    PayPoster,
  },
  data() {
    return {
      orderId: null,
      companyId: null,
      skuName: null,
      dialogVisible: false,
      juheModal: false,
      orderData: {},
      current: 0,
      data: [],
    };
  },
  methods: {
    toShowYPLPay () {
      this.juheModal = true
      this.$refs.PayPoster.init()
    },
    // 初始化
    async init(orderId) {
      this.orderId = orderId;
      const res = await getOrderDetail({ orderId });
      this.companyId = res.data?.companyId
      this.skuName = res.data?.skuName
      this.orderData = { ...res.data, urlList: [] } || {};
      this.data = res.data ? [res.data] : [];
      if (res.data?.orderState) {
        if (res.data?.orderState === 1 || res.data?.orderState === 6) {
          this.current = 0;
        } else if (res.data?.orderState === 2) {
          this.current = 1;
        } else if (res.data?.orderState === 3) {
          this.current = 2;
        } else {
          this.current = 3;
        }
      } else {
        this.current = 0;
      }
      const list = res.data?.remitVoucher?.remitterVoucher.split(",") || [];
      list.forEach((item) => {
        getPrivateImgUrl(item).then((res1) => {
          this.orderData.urlList.push(res1.data);
        });
      });
      this.dialogVisible = true;
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.orderDetail {
  .title {
    font-size: 16px;
    padding: 6px 0;
    margin-bottom: 10px;
    margin-top: 20px;
    border-bottom: 1px solid #dcdfe6;
    display: flex;
    .title_lef {
      flex: 1;
    }
    .title_rig {
      font-size: 14px;
    }
    .blue_Box {
      margin: 0 6px;
      color: #2d8cf0;
      cursor: pointer;
    }

    .blue_Box:hover {
      color: #57a3f4;
    }
  }
}
</style>
